import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';
import { KeyPatternControllerDirective } from './key-pattern-controller.directive';

@Directive({
  selector: 'input[numbersOnly], textarea[numbersOnly]',
})
export class NumbersOnlyDirective extends KeyPatternControllerDirective implements  OnChanges  {
  @Input() additionalAllowedSymbols: string = '';

  protected override pattern = /[0-9]*/g;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['additionalAllowedSymbols']) {
      this.updatePattern();
    }
  }
  constructor(
    protected override element: ElementRef,
    protected override control: NgControl
  ) {
    super(element, control);
  }

  private updatePattern(): void {
    const symbols = this.additionalAllowedSymbols.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'); // Escape special regex characters
    this.pattern = new RegExp(`[0-9${symbols}]*`, 'g');
  }
}
